import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Nav.css';

const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsMenuOpen((v) => !v);

  // ✅ SAFETY: when menu closes, force-enable page scroll
  useEffect(() => {
    // if menu open, you can keep scroll ON or OFF.
    // Your issue is "menu closed -> scroll dead", so we force UNLOCK on close.
    if (!isMenuOpen) {
      document.body.style.overflow = 'auto';
      document.body.style.position = 'static';
      document.documentElement.style.overflow = 'auto';
    }
    return () => {
      // ✅ cleanup (never leave body locked)
      document.body.style.overflow = 'auto';
      document.body.style.position = 'static';
      document.documentElement.style.overflow = 'auto';
    };
  }, [isMenuOpen]);

  // ✅ Close menu on route change (optional safety)
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav className="nav-bar vortrex-header">
      <div className="logo-container">
        <Link to="/" onClick={() => setIsMenuOpen(false)} className="logo-text">
          VORTREX AI
        </Link>
      </div>

      <div className="menu-icon" onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div className={`slide-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="menu-header">🚀 Explore VORTREX</div>

        <Link to="/" state={{ scrollTo: 'homepage' }} onClick={() => setIsMenuOpen(false)}>
          🏡 Homebase
        </Link>
        <Link to="/airdrop" state={{ scrollTo: 'airdrop' }} onClick={() => setIsMenuOpen(false)}>
          🎁 Claim Free Trial
        </Link>
        <Link to="/connect-wallet" state={{ scrollTo: 'connect-wallet' }} onClick={() => setIsMenuOpen(false)}>
          🔷 Bot Activation
        </Link>
        <Link to="/roadmap" state={{ scrollTo: 'roadmap' }} onClick={() => setIsMenuOpen(false)}>
          🧠 Trading System
        </Link>
        <Link to="/features" state={{ scrollTo: 'features' }} onClick={() => setIsMenuOpen(false)}>
          ⚙️ Explore Features
        </Link>

        <Link to="/dashboard" onClick={() => setIsMenuOpen(false)}>
          📊 Dashboard
        </Link>

        <div className="menu-header">📚 More Info</div>

        <Link to="/about" onClick={() => setIsMenuOpen(false)}>
          📖 About Us
        </Link>
        <Link to="/privacy-policy" onClick={() => setIsMenuOpen(false)}>
          🔒 Privacy Policy
        </Link>
        <Link to="/terms-of-use" onClick={() => setIsMenuOpen(false)}>
          📜 Terms of Use
        </Link>
      </div>

      {isMenuOpen && <div className="menu-overlay" onClick={toggleMenu}></div>}
    </nav>
  );
};

export default Nav;
